import { accountsApi } from './api';

/**
 * @typedef {Object} User
 * @property {string} id
 * @property {string} email
 * @property {string} [fullName]
 * @property {string} [username]
 * @property {string} [avatarUrl]
 */

/** @returns {Promise<User>} */
export const getMe = () => accountsApi.get('/api/users/me').then((res) => res.data);

/** @param {Partial<User>} data @returns {Promise<User>} */
export const updateMe = (data) => accountsApi.put('/api/users/me', data).then((res) => res.data);
